import React, { useEffect, useRef } from 'react';
import { ReactComponent as CoolDexIcon } from "../icons/adaptive/CoolDexAdaptiveIcon.svg";
import { ReactComponent as RobotIcon } from "../icons/adaptive/RobotAdaptiveIcon.svg";
import { ReactComponent as NfdIcon } from "../icons/adaptive/NfdAdaptiveIcon.svg";
import { ReactComponent as SomethingCoolIcon } from "../icons/adaptive/SomethingCoolAdaptiveIcon.svg";

const BrandAssetsStartBannerComponent = () => {
	const scrollerRef = useRef<HTMLDivElement | null>(null);
	
	useEffect(() => {
		if (!scrollerRef.current) return;
		
		const scroller = scrollerRef.current;
		const scrollerInner = scroller.querySelector(".brandAssetsStartBanner__content") as HTMLDivElement;
		if (!scrollerInner) return;
		
		const scrollerContent = Array.from(scrollerInner.children);
		
		scrollerContent.forEach((item) => {
			const duplicatedItem = item.cloneNode(true) as HTMLElement;
			duplicatedItem.setAttribute("aria-hidden", "true");
			scrollerInner.appendChild(duplicatedItem);
		});
		
		scroller.setAttribute("data-animated", "true");
	}, []);
	
	return (
		<div className="brandAssetsStartBanner" data-direction="left" data-speed="medium" ref={scrollerRef}>
			<div className="brandAssetsStartBanner__content">
				<CoolDexIcon />
				<NfdIcon />
				<SomethingCoolIcon />
				<RobotIcon />
				<CoolDexIcon />
				<NfdIcon />
				<SomethingCoolIcon />
				<RobotIcon />
			</div>
		</div>
	);
};

export default BrandAssetsStartBannerComponent;